import styled from "styled-components";

export const Container = styled.div`
  max-width: 920px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  margin: 0 0 0.75rem;
  font-size: clamp(2rem, 4vw, 3rem);
`;

export const Description = styled.p`
  margin: 0 0 1.75rem;
  color: ${(props) => props.theme.color.lightBg};
  font-size: 1.1rem;
`;

export const LinkList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

export const SocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  min-height: 48px;
  border: 1px solid ${(props) => props.theme.color.lightBg};
  border-radius: 8px;
  padding: 0.7rem 1rem;
  color: #ffffff;
  font-size: 1rem;
  text-decoration: none;

  &:hover,
  &:focus-visible {
    background: ${(props) => props.theme.color.grayBg};
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }

  svg {
    font-size: 1.15rem;
  }
`;
